/**
 * Delete operation buttons for office employee data display.
 * 1) Selected year  2) Selected year + month/period  3) Current filter selection
 */

import React from 'react';
import { DataType } from './types/DataDisplayTypes';
interface DeleteOperationsProps {
  dataType: DataType;
  filterYear: string;
  filterMonth: string;
  filterPeriod: string;
  filterEmployeeCode: string;
  deleteLoading: boolean;
  onDeleteYearData: () => void;
  onDeleteMonthData: () => void;
  onDeletePeriodData: () => void;
  onDeleteSelection: () => void;
}

export const DeleteOperations: React.FC<DeleteOperationsProps> = ({
  dataType,
  filterYear,
  filterMonth,
  filterPeriod,
  filterEmployeeCode,
  deleteLoading,
  onDeleteYearData,
  onDeleteMonthData,
  onDeletePeriodData,
  onDeleteSelection,
}) => {
  const selectionEnabled =
    dataType === 'salary'
      ? !!(filterYear && filterMonth)
      : !!(filterYear && filterPeriod);

  const confirm = (fn: () => void) => {
    if (window.confirm('本当に削除してもよろしいですか？')) {
      fn();
    }
  };

  return (
    <div className="delete-operations">
      <div className="delete-buttons">
        <button
          type="button"
          className="delete-btn delete-year"
          onClick={() => confirm(onDeleteYearData)}
          disabled={deleteLoading || !filterYear}
          title={!filterYear ? '年を選択してください' : ''}
        >
          {deleteLoading ? '削除中...' : filterYear ? `${filterYear}年のデータを削除` : '選択年のデータを削除'}
        </button>

        {dataType === 'salary' ? (
          <button
            type="button"
            className="delete-btn delete-month"
            onClick={() => confirm(onDeleteMonthData)}
            disabled={deleteLoading || !filterYear || !filterMonth}
            title={!filterYear || !filterMonth ? '年と月を選択してください' : ''}
          >
            {deleteLoading ? '削除中...' : filterYear && filterMonth ? `${filterYear}年${filterMonth}月のデータを削除` : '選択年月のデータを削除'}
          </button>
        ) : (
          <button
            type="button"
            className="delete-btn delete-period"
            onClick={() => confirm(onDeletePeriodData)}
            disabled={deleteLoading || !filterYear || !filterPeriod}
            title={!filterYear || !filterPeriod ? '年と期を選択してください' : ''}
          >
            {deleteLoading ? '削除中...' : filterYear && filterPeriod ? `${filterYear}年${filterPeriod}期のデータを削除` : '選択年期のデータを削除'}
          </button>
        )}

        <button
          type="button"
          className="delete-btn delete-selection"
          onClick={onDeleteSelection}
          disabled={deleteLoading || !selectionEnabled}
          title={!selectionEnabled ? (dataType === 'salary' ? '年と月を選択してください' : '年と期を選択してください') : ''}
        >
          {deleteLoading ? (
            '削除中...'
          ) : (
            <span className="delete-selection-label">
              選択されている
              <br />
              データを削除
            </span>
          )}
        </button>
      </div>
    </div>
  );
};
